export default __webpack_public_path__ + "media/samples/FEATURED_VIDEOS-190eeb81.jpg";